exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop_classify[data-v-291b07b4]{padding:30px}.top_exp[data-v-291b07b4]{margin-bottom:20px}\n", ""]);

// exports
